<template>
  <span class="relative inline-block" @mouseenter="show = true" @mouseleave="show = false" @focus="show = true" @blur="show = false" tabindex="0">
    <slot />
    <span
      v-if="show && enabled"
      :class="[
        'absolute z-50 bg-gray-800 text-white px-4 py-2 rounded shadow-lg text-sm pointer-events-auto flex flex-col items-center',
        'w-[300px]',
        tooltipPositionClass,
        props.position === 'left' ? '!left-auto !right-full !top-1/2 !-translate-y-1/2 !mb-0 !mt-0 !-translate-x-0 !mr-2' : '',
        props.position === 'right' ? '!left-full !right-auto !top-1/2 !-translate-y-1/2 !mb-0 !mt-0 !-translate-x-0 !ml-2' : '',
        props.position === 'bottom' ? '!top-full !bottom-auto !left-1/2 !-translate-x-1/2 !mt-2 !mb-0' : '',
        props.position === 'top' ? '!bottom-full !top-auto !left-1/2 !-translate-x-1/2 !mb-0 !mt-0' : ''
      ]"
      :style="tooltipStyle"
      role="tooltip"
      ref="tooltipRef"
    >
      <!-- Arrow -->
      <span
        :class="[
          'absolute w-3 h-3',
          props.position === 'top' ? 'bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2' : '',
          props.position === 'bottom' ? 'top-0 left-1/2 -translate-x-1/2 -translate-y-1/2' : '',
          props.position === 'left' ? 'right-0 top-1/2 -translate-y-1/2 translate-x-1/2' : '',
          props.position === 'right' ? 'left-0 top-1/2 -translate-y-1/2 -translate-x-1/2' : ''
        ]"
        aria-hidden="true"
      >
        <svg viewBox="0 0 12 12" class="w-3 h-3" fill="none">
          <polygon :points="arrowPoints" fill="#1f2937" />
        </svg>
      </span>
      <span class="block">{{ text }}</span>
    </span>
  </span>
</template>

<script setup>
import { ref, computed, onMounted, watch } from 'vue';
// Arrow points for each direction (opposite direction)
const arrowPoints = computed(() => {
  switch (props.position) {
    case 'top':
      return '0,0 12,0 6,12'; // Upward arrow
    case 'bottom':
      return '6,0 12,12 0,12'; // Downward arrow
    case 'left':
      return '0,0 12,6 0,12'; // Left arrow
    case 'right':
      return '12,0 12,12 0,6'; // Right arrow
    default:
      return '0,0 12,0 6,12';
  }
});
const props = defineProps({
  text: {
    type: String,
    required: true
  },
  position: {
    type: String,
    default: 'top', // top, bottom, left, right
    validator: v => ['top', 'bottom', 'left', 'right'].includes(v)
  },
  enabled: {
    type: Boolean,
    default: true
  }
});
const show = ref(false);
const tooltipRef = ref(null);

// The position prop determines where the tooltip appears relative to the slot item
const tooltipPositionClass = computed(() => {
  switch (props.position) {
    case 'top':
      return 'left-1/2 bottom-full mb-2 -translate-x-1/2'; // Tooltip above slot
    case 'bottom':
      return 'left-1/2 top-full mt-2 -translate-x-1/2'; // Tooltip below slot
    case 'left':
      return 'right-full top-1/2 -translate-y-1/2 mr-2'; // Tooltip left of slot
    case 'right':
      return 'left-full top-1/2 -translate-y-1/2 ml-2'; // Tooltip right of slot
    default:
      return 'left-1/2 bottom-full mb-2 -translate-x-1/2';
  }
});


const tooltipStyle = ref('');
</script>

